import React, { useState, useEffect } from "react";

function PublicIntroAnimation({ project, thumbnailUrl, isVisible, onComplete }) {
    const [isFadingOut, setIsFadingOut] = useState(false);
    const displayTime = 4000;
    const fadeOutDuration = 1000;

    useEffect(() => {
        if (!isVisible) return;

        const fadeOutTimer = setTimeout(() => {
            setIsFadingOut(true);
        }, displayTime);

        const completeTimer = setTimeout(() => {
            if (onComplete) {
                onComplete();
            }
        }, displayTime + fadeOutDuration);

        return () => {
            clearTimeout(fadeOutTimer);
            clearTimeout(completeTimer);
        };
    }, [isVisible, onComplete, displayTime, fadeOutDuration]);

    useEffect(() => {
        if (isVisible) {
            setIsFadingOut(false);
        }
    }, [isVisible]);

    if (!isVisible) {
        return null;
    }

    return (
        <div
            className={`pointer-events-auto fixed inset-0 z-[9999] box-border flex select-none items-center justify-center bg-black/60 max-[440px]:p-[10vw] bp-lg:px-[10vw] bp-lg:pb-[10vh] bp-lg:pt-[20vh] ${
                isFadingOut ? "animate-intro-fade-out" : "animate-intro-fade-in"
            }`}
            style={{
                "--fade-out-duration": `${fadeOutDuration}ms`,
            }}
        >
            {thumbnailUrl && (
                <img
                    src={thumbnailUrl}
                    alt={`${project?.name}のサムネイル`}
                    className="h-auto max-h-full w-auto max-w-full animate-intro-scale-in object-contain"
                />
            )}
        </div>
    );
}

export default PublicIntroAnimation;
